
import { defineComponent, onMounted, reactive, toRefs,getCurrentInstance } from 'vue'
import searchBtn from '../common/mobileSearchEl.vue'
import {useRouter,useRoute} from 'vue-router'
// import Footer from '@/components/common/footer.ftl'
// import Footer from '@/components/common/footer.vue'
import Footer1 from '@/components/common/footer.vue'
import Footer2 from '@/components/footer/footer.vue'
import {ArrowRight} from '@element-plus/icons-vue'
import tool from '@/utils/plugins/tools.js'
export default defineComponent({
    components:{searchBtn,Footer1,Footer2,ArrowRight},
    setup(props) {
        const {proxy,appContext}= getCurrentInstance() as any
        const axios =appContext.config.globalProperties.axios
        const router=useRouter()
        const Cookies = appContext.app.config.globalProperties.Cookies
        const state:any=reactive({
            platformJson:appContext.config.globalProperties.platformJson,
            searchBoxMax:window.innerHeight*0.4,
            showPopover:false,
            searchList:[],
            searchValue:'',
            searchTotal:0,
            homeList:[],
            titleList:[],
            typeList:[],
            videoList:[],
            showAws6:''
        })
        const methods:any=reactive({
            handleClickLogo:(val:any)=>{
                window.open(val,'_blank')
            },
            //点击搜索的内容
            handleSelectId:(val:any)=>{
                router.push(`/marticle/${val.id}`)
            },
            changeSearchValue:(val:any)=>{
                state.searchValue=val
                methods.getSearchList(val)
            },
            getSearchList:(val:any)=>{
                if(val==''){
                    state.searchList=[]
                }else{
                    axios.get('/open/search',{
                       key:state.searchValue
                    }).then((res:any)=>{
                        if(res.data.code==200){
                            state.searchList=res.data.data.list
                            state.searchTotal=res.data.data.total
                            state.showPopover=true
                        }

                    })
                }
            },
            // 查询首页数据
            getDataList:()=>{
                axios.get('/open/home',{
                }).then((res:any)=>{
                    if(res.data.code==200){
                        let list:any=JSON.parse(res.data.data)
                        let routeType= window.location.href.includes('#')//是否是hash模式
                        let routePath=routeType?'#/marticle/':'marticle/'
                        let titleList:any=[]
                        let typeList:any=[]
                        let videoList:any=[]
                        list.map((item:any)=>{
                            if(item.jumpUrl){
                                // item.jumpUrl=window.location.origin+'/marticle/'+item.jumpUrl?.slice(2)
                                item.jumpUrl=window.location.origin+window.location.pathname+routePath+item.jumpUrl?.slice(2)
                            }
                            if(item.list){
                                item.list.map((one:any)=>{
                                    // one.jumpUrl=window.location.origin+'/marticle/'+one.jumpUrl?.slice(2)
                                    one.jumpUrl=window.location.origin+window.location.pathname+routePath+one.jumpUrl?.slice(2)
                                })
                            }
                            if(item.groupType==1){
                                typeList.push(item)
                            }else if(item.groupType==2){
                                titleList.push(item)
                            }else if(item.groupType==3){
                                videoList.push(item)
                            }
                        })
                        state.typeList=typeList
                        state.titleList=titleList
                        state.videoList=videoList
                        console.log(typeList,titleList,111)
                    }
                })
            },
            // 打开更多
            openMore:(val:any)=>{
                if(val.jumpUrl){
                    window.location.href=val.jumpUrl
                    // window.open(val.jumpUrl,'_blank')
                }
            },
            toPaasSix:()=>{
                if(state.showAws6){
                    window.location.href='https://docs.awspaas.com/help/index.html'
                }
            },
            //视频加载完毕
            onVideoLoaded:(item:any)=>{
                item.videoLoaded=true
            }
        })
        onMounted(()=>{
            document.title=`${state.platformJson.name} - 帮助中心`
            methods.getDataList()
            tool.dataPiont({
                channelName:"AWS PaaS-帮助中心",
                behaviorNo:"0101",
                eventNo:tool.searchParam("_event")||tool.searchParam("utm_campaign"),
                browserId:Cookies.get("BROWSER_ID")||appContext.app.config.globalProperties.$fingerprint,
                url:window.location.href,
                title:document.title,
                utmsource:tool.searchParam("utm_source"),
                visitDate:tool.getCurrentFormattedTime(),
                device:tool.isMobile()?'mobile':'pc',
                mobile:'',
                visitType:'A'
            })
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    }
})
